import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format een datum als Nederlandse notatie DD-MM-YYYY.
 * Accepteert een ISO-string (YYYY-MM-DD of full ISO), een Date-object of null.
 * Retourneert een lege string voor ongeldige input, zodat aanroepers geen 'Invalid Date' tonen.
 */
export function formatDateNL(input) {
  if (!input) return '';
  try {
    // ISO date-only string 'YYYY-MM-DD' → handmatige swap (voorkomt timezone-issues)
    if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
      const [y, m, d] = input.split('-');
      return `${d}-${m}-${y}`;
    }
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return typeof input === 'string' ? input : '';
    return d.toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch {
    return typeof input === 'string' ? input : '';
  }
}
